import { createAction, createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';

const INITIAL_STATE = Immutable({
  route: '',
  title: '',
});

export const navigate = createAction('NAVIGATE');
export const setTitle = createAction('SET_TITLE');

const reducers = createReducer({
  [navigate]: (state, { route }) => state.merge({ route }),
  [setTitle]: (state, title) => state.merge({ title }),
}, INITIAL_STATE);

export default reducers;
